// Shared display formatters for the MATCH module.
//
// This file exists because the same "fetched X ago" helper was written twice —
// once in settings/AppDirectSection.js for the lookup-cache timestamp, once in
// board/FieldRow.js for the product-catalog timestamp. That is the same
// duplicate-a-helper pattern that put six invented field paths into the Magic
// Mapping prompt and a stale copy of the Contract H labels into
// MagicMapFlowModal. One definition, imported.

/**
 * Render an ISO-8601 timestamp as a coarse "how long ago" string.
 *
 * Returns null for a missing/empty value so callers choose their own wording —
 * Settings shows "never" for a cache that has never been populated, while the
 * product combobox omits the line entirely. Encoding either default here would
 * force the other caller to special-case it back out.
 */
export function formatRelativeTime(iso) {
  if (!iso) return null;
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (Number.isNaN(diff)) return null;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
